import { getGroupFilesHubFREStore } from '../store/GroupFilesHubFREStore';

export function shouldShowSPCallout(): boolean {
    // We should show this callout if: shouldShowFRECallouts is true, AND the SP Callout has not been shown
    return (
        getGroupFilesHubFREStore().shouldShowFRECallouts &&
        !getGroupFilesHubFREStore().spCalloutShown
    );
}
